var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-nav-bar" }, [
    _c("div", { staticClass: "nav-buttons-wrapper" }, [
      _c("a", { attrs: { href: "/", title: "Home" } }, [
        _c("img", {
          staticClass: "nav-heder-icon",
          attrs: { src: _vm.homeIcon },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "navs-wrapper" }, [
        _c(
          "a",
          {
            attrs: { href: "/app/sign-up/role" },
            on: { click: _vm.handleClickSignup },
          },
          [_c("span", { staticClass: "nav-button" }, [_vm._v("Sign up")])]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: "/auth/login" } }, [
          _c(
            "span",
            { staticClass: "nav-button", on: { click: _vm.handleClickLogin } },
            [_vm._v("Login")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }